import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

declare var $: any;

interface Section {
  title: string;
  description: string;
}

interface Logo {
  src: string;
  alt: string;
}

@Component({
  selector: 'app-ai-consulting',
  templateUrl: './ai-consulting.component.html',
  styleUrls: ['./ai-consulting.component.css'],
  standalone: false
})
export class AiConsultingComponent implements OnInit, AfterViewInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Consultoría de IA');
  }

  ngAfterViewInit() {
    $('#aiCarousel').carousel({ interval: 3000, ride: 'carousel' });
  }

  logos: Logo[][] = [
    [
      { src: 'assets/img/openai-logo.svg', alt: 'OpenAI' },
      { src: 'assets/img/microsoft-logo.svg', alt: 'Microsoft' },
      { src: 'assets/img/gemini-logo.svg', alt: 'Google Gemini' }
    ],
    [
      { src: 'assets/img/aws.png', alt: 'AWS' },
      { src: 'assets/img/mistral.svg', alt: 'Mistral' }
    ]
  ];

  sections: Section[] = [
    {
      title: 'DIAGNÓSTICO Y OPORTUNIDADES',
      description: 'Analizamos tus procesos actuales para identificar dónde la inteligencia artificial puede generar mayor impacto: reducción de costes, eficiencia operativa o mejora de la experiencia del cliente.'
    },
    {
      title: 'SELECCIÓN E IMPLANTACIÓN',
      description: 'Te ayudamos a elegir la solución de IA más adecuada para tu negocio — propia o de terceros — y acompañamos su implantación, sin que necesites conocimientos técnicos previos.'
    },
    {
      title: 'ACOMPAÑAMIENTO Y EVOLUCIÓN',
      description: 'Aseguramos la adopción real por parte del equipo, medimos resultados y ajustamos la solución conforme el negocio evoluciona. La IA no es un proyecto puntual, es una capacidad que crece contigo.'
    }
  ]

}
